import React, { useContext, useRef, useState, useEffect } from 'react'
import { Context } from "../contexts/AppContext";
import { useNavigate } from 'react-router-dom';
import { deleteData, getData, postData } from '../../lib/utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPencil, faEllipsisH } from "@fortawesome/free-solid-svg-icons";

function GalleryThumbnail() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  console.log("gallery Thumbnail ",appState)
  const navigate = useNavigate();
  const [menuOpenState, setMenuOpenState] = useState({});
  const menuRef = useRef();

  useEffect(()=>{

  },[appState.modalData])
  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpenState({});
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const galleryBtnhandler = async (evt) => {
 
    const galleryId = evt.currentTarget.id;
    const galleryName = evt.currentTarget.dataset.galleryname;

    const json = await getData(`galleries/get-gallery-videos/${galleryId}`);
    if (json) {
      setAppState((prevState) => ({
        ...prevState,
        currentGalleryName: galleryName,
        currentDBGalleryId: galleryId,
        templateId: json.templateId,
        activePanel: "PhotosC",
        videoArr: json.videos,
      }));
      navigate(`/studio/galleries/${galleryId}/photos`);
    }
  };

  const toggleMenu = (galleryId, e) => {
    e.stopPropagation(); // Prevents gallery click
    setMenuOpenState((prevState) => ({
      [galleryId]: !prevState[galleryId]
    }));
  };

  const renameGallery = (id) => {
    setAppState((prevState) => ({
      ...prevState,
      currentDBGalleryId:id,
      modalData: { ...prevState.modalData, type: "RenameGalleryModal", isOpen: true, targetId: id }
    }));
  };
 

    const deleteGallery = async (id) => {
         const result = window.confirm("Are you sure you want to delete this gallery?");
           if (!result) {
            return;
           }


           console.log("app State ",`${appState.adminDetails.id}/${appState.currentFolderData._id}/${id}`)
           

                const folderPath =`${appState.adminDetails.id}/${appState.currentFolderData._id}/${id}`;
                
               try { 
           
                  const json = await postData("products/delete-file", {
                   folderName:folderPath
                  })
                  if (json) {
                   console.log("Delete Gallery")
                  }
               } catch (error) {
                 console.error("Error deleting file:", error);
               }

      try {
        const response = await deleteData(`galleries/gallery/${id}`);
        if (response) {
      
          window.location.reload();
        }
      } catch (error) {
        console.error("Error deleting folder:", error);
      }
    };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "short" });
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div style={{ position: 'relative', width: "98%", padding: "30px", display: "flex", flexWrap: "wrap", gap: "10px" , height: "calc(100% - 130px)", overflow:"auto" }}>
     
      {appState.currentFolderData.galleries.map((item, index) => (
        <div
          key={item._id}
          id={item._id}
          data-galleryname={item.name}
          className='relative text-sm font-bold text-left border bg-[#f0f2f5] flex flex-col items-start cursor-pointer'
          onClick={galleryBtnhandler}
          style={{ width: "285px", height:"250px" }}
        >
          <img
            className="w-full p-2"
            src={
              item?.backgroundMedia?.imgUrl
                ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.backgroundMedia.imgUrl}`
                : "../../../img/thumbnail/gallery/placeholder-image.jpg"
            }
          />

          <div className='px-4 text-left w-full flex justify-between items-center'>
            <span>{item.name}</span>
            <button
              onClick={(e) => toggleMenu(item._id, e)}
              className="text-gray-600 hover:text-gray-800"
            >
              <FontAwesomeIcon icon={faEllipsisH} />
            </button>
          </div>

          <div className='px-4 text-xs font-semibold text-left'>{formatDate(item.createdAt)}</div>

          {menuOpenState[item._id] && (
            <div
              ref={menuRef}
              className="absolute -bottom-14 right-0 w-40 bg-white border rounded-lg shadow-lg p-2 z-10"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => renameGallery(item._id)}
                className="flex items-center gap-x-2 w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                <FontAwesomeIcon icon={faPencil} style={{ color: "#1F2937" }} /> Rename
              </button>
              <button
                onClick={() => deleteGallery(item._id)}
                className="flex items-center gap-x-2 w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                <FontAwesomeIcon icon={faTrash} style={{ color: "#1F2937" }} /> Delete
              </button>
            </div>
          )}
        </div>
      ))}




    </div>
  );
}

export default GalleryThumbnail;
